import script from "./SimulateChartRequiredCollateralTxt.vue?vue&type=script&setup=true&lang=js"
export * from "./SimulateChartRequiredCollateralTxt.vue?vue&type=script&setup=true&lang=js"

import "./SimulateChartRequiredCollateralTxt.vue?vue&type=style&index=0&id=06b3f298&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06b3f298"]])

export default __exports__